import { PathCardinalPointEnum } from '../../../enum/path/path-cardinal-point.enum';
import { PathTypeEnum } from '../../../enum/path/path-type.enum';
import { BoPathTrjInterface } from '../../../interface/back-office/path/path-trj/bo-path-trj.interface';
import { GmapsPoint } from '@infodata-group/inf-commons-tools';
import { StandardEntity } from '@infodata-group/inf-commons';
import * as uuid from 'uuid';

export class PathPoint extends StandardEntity {
  public cap: string;
  public heureDebut: string;
  public latitude: number;
  public latitudeOrigin: PathCardinalPointEnum;
  public longitude: number;
  public longitudeOrigin: PathCardinalPointEnum;
  public type: PathTypeEnum;

  public frontDate: Date;

  constructor(o: BoPathTrjInterface) {
    super(uuid.v4());
    this.cap = o.cap;
    this.heureDebut = o.heureDebut;
    this.latitude = parseFloat(o.latitude);
    this.latitudeOrigin = o.latitudeOrigin;
    this.longitude = parseFloat(o.longitude);
    this.longitudeOrigin = o.longitudeOrigin;
    this.type = o.type;
  }

  public toGmapsPoint(): GmapsPoint {
    return new GmapsPoint('', this.latitude, this.longitude);
  }
}
